import { render, staticRenderFns } from "./notificationList.vue?vue&type=template&id=a66990c2&scoped=true&"
import script from "./notificationList.vue?vue&type=script&lang=js&"
export * from "./notificationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a66990c2",
  null
  
)

export default component.exports